import React from 'react'
import './index.css'

function Loader(props) {
    if (props.visible) {
        return (
            <div id="loading" style={{
                background: 'rgba(255,255,255,0.5)',
                width: '100%',
                height: '100%',
                zIndex: 99999,
                position: 'fixed',
            }}>
                <div style={{
                    left: '50%',
                    top: '50%',
                    position: 'absolute'
                }} >
                    <div className="lds-spinner">
                        <div></div><div></div><div></div>
                        <div></div><div></div><div></div>
                        <div></div><div></div><div></div>
                        <div></div><div></div><div></div>
                    </div>
                </div>
            </div>
        )
    } else {
        return false
    }
}

export default Loader